import { Select as NDSSelect } from "@narmi/design_system";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface SelectProps<T extends FieldValues> {
  control: Control<T, unknown>;
  name: Path<T>;
  label: string;
  items: { code: string; name: string }[];
  disabled?: boolean;
}

function Select<T extends FieldValues>(props: SelectProps<T>) {
  return (
    <div className="sentry-mask">
      <Controller
        name={props.name}
        control={props.control}
        render={function ({ field: { onChange, value }, fieldState: { error } }) {
          return (
            <NDSSelect
              value={value}
              onChange={onChange}
              errorText={error?.message}
              label={props.label}
              disabled={props.disabled}
            >
              {props.items.map((item) => (
                <NDSSelect.Item key={item.code} value={item.code}>
                  <span className="sentry-mask">{item.name}</span>
                </NDSSelect.Item>
              ))}
            </NDSSelect>
          );
        }}
      />
    </div>
  );
}

export { Select };
